import { __assign, __makeTemplateObject, __rest } from "tslib";
import styled from 'styled-components';
import React from 'react';
var SUnstyledSelect = styled.select(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n"])));
/** Usage:
 *  Just drop this inside an element of your choice. It will overlap it with opacity 0,
 *  and trigger the native select options when clicked. Important: Your element needs to have
 *  position: relative; */
export var UnstyledSelect = function (_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return React.createElement(SUnstyledSelect, __assign({}, restProps), children);
};
var templateObject_1;
//# sourceMappingURL=UnstyledSelect.js.map